import Slider from 'react-slick'

import './info-carousel.styl'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

function InfoCarousel() {
  const settings = {
    dots: true,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  }

  return (
    <Slider className="info-carousel" {...settings}>
      <div className="info-carousel__slide">
        <div className="info-carousel__slide__info">
          Mobile biological lab to support first response in Arbovirus outbreaks is funded within a European Union’s Horizon Europe research and innovation programme under Grant Agreement № 101099283.
          <br />
          <br />
          The MOBVEC laboratory combines smart traps, citizen science, field measurements and Earth observation data to provide rapid response during outbreaks and effectively support responders.
          <br />
          <br />
          This digital platform collects and visualises multiple data streams including an overview of the environment, planning the trap sampling strategy, real-time results and lab data, and epidemiological and risk maps.
        </div>
        <img className="info-carousel__slide__img" src="/img/login/slide1.svg" />
      </div>
      <div className="info-carousel__slide">
        <img className="info-carousel__slide__img" src="/img/login/slide2.jpg" />
      </div>
      <div className="info-carousel__slide">
        <img className="info-carousel__slide__img" src="/img/login/slide3.jpg" />
      </div>
      <div className="info-carousel__slide">
        <img className="info-carousel__slide__img" src="/img/login/slide4.jpg" />
      </div>
    </Slider>
  )
}

export default InfoCarousel
